import { Theme, ThemeProvider } from "@emotion/react";
import { createTheme, Paper, SxProps } from "@mui/material";
import React from "react";
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridColDef } from "@mui/x-data-grid";

interface DataGridProps {
    rows: any[];
    columns: GridColDef[];
    pagination: any;
    pageSizeOptions: number[];
    checkboxSelection?: boolean;
    sx?: SxProps<Theme>;
}

const DataGridComponent = (props: DataGridProps) => {
    //const items = [1, 2, 3, 4, 5, 6];
    const theme = createTheme(
        {
            palette: {
                primary: { main: '#1976d2' },
            },
        },
        ptBR,
    );

    return <ThemeProvider theme={theme}>
        <Paper 
            sx={{
                display: "flex",
                width: "100%",
            }}
            //sx={{ height: 400, width: '100%' }}
        >
            <DataGrid
                rows={props.rows}
                columns={props.columns}
                initialState={{ pagination: props.pagination }}
                pageSizeOptions={props.pageSizeOptions}
                checkboxSelection={props.checkboxSelection}
                sx={props.sx}
            />
        </Paper>
    </ThemeProvider>
}

export default DataGridComponent